export default __webpack_public_path__ + "static/bg-header-ee78a80761ae44c39131cd060f46b8ec.jpg";